import { render, staticRenderFns } from "./archived_badge.vue?vue&type=template&id=0a9a6a51"
import script from "./archived_badge.vue?vue&type=script&lang=js"
export * from "./archived_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports